import { hasNoInvalidCharacters } from '@monorepo/shared/utils/validators';
import React from 'react';
import { useField } from 'react-final-form';
import { type ConditionalFieldValueInputProps } from './ConditionalFieldValueFactory';
import { StyledInput } from './styled';

export function ConditionalTextField({
  name,
  ...inputFieldProps
}: ConditionalFieldValueInputProps['inputFieldProps']) {
  const {
    input: { value: fieldValue, onChange: onFieldValueChange },
  } = useField(name, {
    validate: hasNoInvalidCharacters('|'),
  });

  return (
    <StyledInput
      name={name}
      onChange={onFieldValueChange}
      value={fieldValue}
      fullWidth
      dontSaveSpaceForErrorText
      {...inputFieldProps}
    />
  );
}
